import type { TransportResponse } from 'atemoya-contracts';

export enum TransportRequestTypes {
    INIT = 'INIT',
    ACTION = 'ACTION',
}

export interface ITransportService {
    send(type: string, payload: Record<string, unknown>, clientRequestId: string): Promise<TransportResponse>;
    connect?(): void | Promise<void>;
    disconnect(): void;
}
